import { demoRegistry } from "@/demos/registry";
import type { DemoId } from "@/demos/types";

export function initialDemoFromSearch(search: string): DemoId {
  const requested = new URLSearchParams(search).get("demo");
  return demoRegistry.some((demo) => demo.id === requested) ? requested as DemoId : "see";
}

export function replaceDemoInUrl(id: DemoId): void {
  const url = new URL(window.location.href);
  url.searchParams.set("demo", id);
  window.history.replaceState(null, "", url);
}
